module.exports = __webpack_public_path__ + "img/sardinia.5505903c.svg";